package com.eladfinish.bible.contest.screens.chapterComplete.features.shuffle

import androidx.compose.ui.text.AnnotatedString

data class RevealCardData(
    val otPasuk: String,
    val reysha: AnnotatedString,
    val seyfa: AnnotatedString,
)
